var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 14L20 20","stroke":"#C0C8D0","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"9.5","cy":"9.5","r":"5.5","stroke":"#C0C8D0","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }